// Define the navigation item interface
export interface NavigationItem {
  path: string;
  label: string;
  icon: string;
  subItems?: NavigationItem[];
}

// Single source of truth for navigation items
export const navigationItems: NavigationItem[] = [
  { path: '/dashboard', label: 'Home', icon: '🏠' },
  { 
    path: '/dashboard/work', 
    label: 'Work', 
    icon: '💼',
    subItems: [
      { path: '/dashboard/work', label: 'Dashboard', icon: '📊' },
      { path: '/dashboard/work-settings', label: 'Konfiguration', icon: '⚙️' }
    ]
  },
  { 
    path: '/dashboard/workouts', 
    label: 'Workouts', 
    icon: '🏋️',
    subItems: [
      { path: '/dashboard/workouts', label: 'Dashboard', icon: '📊' },
      { path: '/dashboard/workouts-list', label: 'Workout Liste', icon: '📋' },
      { path: '/dashboard/workout-exercises', label: 'Übungen', icon: '💪' }
    ]
  },
  { 
    path: '/dashboard/moscht', 
    label: 'Moscht', 
    icon: '⛽',
    subItems: [
      { path: '/dashboard/moscht', label: 'Dashboard', icon: '📊' },
      { path: '/dashboard/moscht/tankungen', label: 'Tankungen', icon: '🛢️' },
      { path: '/dashboard/moscht/events', label: 'Events', icon: '📅' },
      { path: '/dashboard/moscht/logs', label: 'Logs', icon: '📝' },
      { path: '/dashboard/moscht/cars', label: 'Fahrzeuge', icon: '🚗' },
      { path: '/dashboard/moscht/settings', label: 'Konfiguration', icon: '⚙️' }
    ]
  },
  { 
    path: '/dashboard/vega', 
    label: 'VeGa', 
    icon: '🚲',
    subItems: [
      { path: '/dashboard/vega', label: 'Dashboard', icon: '📊' },
      { path: '/dashboard/vega/rides', label: 'Fahrten', icon: '🚴' },
      { path: '/dashboard/vega/maintenance', label: 'Wartung', icon: '🔧' },
      { path: '/dashboard/vega/settings', label: 'Konfiguration', icon: '⚙️' }
    ]
  },
  {
    path: '/bike',
    label: 'Bike',
    icon: '🚲',
    subItems: [
      { path: '/bike', label: 'Velos', icon: '🚲' },
      { path: '/bike/maintenance', label: 'Wartung', icon: '🔧' },
      { path: '/bike/settings', label: 'Konfiguration', icon: '⚙️' }
    ]
  }
];

// Add Learning Cards to the navigation items
navigationItems.push({
  path: '/dashboard/learning-cards',
  label: 'Cards',
  icon: '🃏',
  subItems: [
    { path: '/dashboard/learning-cards/history', label: 'Learning History', icon: '📚' }
  ]
});

// Add Run to the navigation items
navigationItems.push({ path: '/dashboard/run', label: 'Run', icon: '🏃' });

// Add Profile at the end of the array to make it appear at the end of More options
navigationItems.push({ path: '/dashboard/profile', label: 'Profile', icon: '👤' });

// Function to check if a navigation item or any of its subitems is active
export const isNavItemActive = (item: NavigationItem, currentPath: string): boolean => {
  if (currentPath === item.path) return true;
  if (item.subItems) {
    return item.subItems.some(subItem => currentPath === subItem.path);
  }
  return false;
};

// Function to get items that should not show subitems in mobile view
export const shouldHideSubItems = (label: string): boolean => {
  return ['Work', 'Moscht', 'Workouts', 'VeGa', 'Bike'].includes(label);
};
